<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">

      <el-select v-model="filteringProductID" @change="search" placeholder="請選擇商品" style="width: 180px;margin-left: 10px;" filterable>
        <el-option v-for="product in $store.state.product.list.filter(o=>o.IsActive)" :key="product.ID"
          :value="product.ID"
          :label="product.Tw.Name"/>
      </el-select>

      <!-- <el-date-picker
        @change="search"
        width="100px"
        v-model="filteringMonth"
        type="month"
        placeholder="選擇月份"
        :clearable="false">
      </el-date-picker> -->

      <el-date-picker
        v-model="filteringDateRange"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="開始日期"
        end-placeholder="結束日期"
        @input="onDateRangeChanged">
      </el-date-picker>

    </template>
    <template slot="right">
      <el-button @click="onExportExcel" style="margin-right: 20px;">匯出</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)" @sort-change="onTableSortChanged">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="訂單號碼" width="130px">
          <template slot-scope="scope">
            <a class="order-id" href="javascript:;" @click="$router.push({ name: 'order-detail', params: { id: scope.row.ID }, query: routeQuery})">{{scope.row | getOrderID}}</a>
          </template>
        </el-table-column>
        <el-table-column sortable :sort-orders="['descending','ascending',null]" label="訂單日期" width="120px">
          <template slot="header">
            <div class="cell" style="display: inline-flex; margin-right: 0">訂單日期
            </div>
          </template>
          <template slot-scope="scope">
            {{scope.row.CreatedAt | dateFormat}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="訂單狀態" width="80px">
          <template slot-scope="scope">
            <span :class="`order-status ${scope.row.OrderStatus}`">{{scope.row.OrderStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款狀態" width="110px">
          <template slot-scope="scope">
            <span :class="`payment-status ${scope.row.PaymentStatus}`">{{scope.row.PaymentStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="送貨狀態" width="80px">
          <template slot-scope="scope">
            <span :class="`logistics-status ${scope.row.LogisticsStatus}`">{{scope.row.LogisticsStatus}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="訂購人">
          <template slot-scope="scope">
            <span v-if="scope.row.User">
              {{scope.row.User && (scope.row.User.Profile.Name)}} -
              {{scope.row.User && scope.row.User.Profile && (scope.row.User.Profile.Email)}}
            </span>
            <span v-else-if="scope.row.BuyerInfo">
              [未註冊]
              {{!scope.row.User && scope.row.BuyerInfo && (scope.row.BuyerInfo.Name)}} -
              {{!scope.row.User && scope.row.BuyerInfo && scope.row.BuyerInfo.Email}}
            </span>
          </template>
        </el-table-column>
        <el-table-column sortable :sort-orders="['descending','ascending',null]" label="合計(該商品)" width="150px">
          <template slot="header">
            <div class="cell" style="display: inline-flex; margin-right: 0">合計(該商品)
            </div>
          </template>
          <template slot-scope="scope">
            NT${{scope.row.amountOfTheProduct|amountFormat}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="合計" width="110px">
          <template slot-scope="scope">
            NT${{scope.row.PaidAmount|amountFormat}}
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
// import { getOrderID } from '@/utils/filters/formatter.js'
// excel
import ExcelGenerator from '../../order/excel'
import XLSXSaver from '@/utils/excel/xlsx-saver.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: '全部',
      filteringProductID: null,
      filteringDateRange: null,
      filteringMonth: moment(),
      // modal
      isShowAddeditModal: false,
      editingObj: null,
      // sort
      sorting: {
        sortBy: null,
        sortOrder: null // asc or desc
      }
    }
  },
  computed: {
    routeQuery () {
      let query = {
        frompage: this.currentPage
      }
      if (this.filteringStatus) query.filteringStatus = this.filteringStatus
      if (this.keyword) query.keyword = this.keyword
      if (this.filteringDateRange) query.filteringDateRange = JSON.stringify(this.filteringDateRange)
      return query
    }
  },
  methods: {
    // for base
    setLoading (key, isLoading) {
      this.isLoading = isLoading
    },
    onTableSortChanged (e) {
      this.toggleSort(e.column.label, e.order)
    },
    toggleSort (sortKey, sortOrder) {
      console.log(`sortByOrderCount`, sortKey, sortOrder)
      try {
        // 2. sort by detail
        this.sorting.sortBy = sortKey
        this.sorting.sortOrder = sortOrder
        // 3. reloadTableData
        this.currentPage = 1
        this.searchedObjs.sort((o1, o2) => {
          if (this.sorting.sortBy === '合計(該商品)') {
            return (this.sorting.sortOrder === 'ascending' ? 1 : -1) * (o1.amountOfTheProduct - o2.amountOfTheProduct)
          } else if (this.sorting.sortBy === '訂單日期') {
            return (this.sorting.sortOrder === 'ascending' ? 1 : -1) * ((moment(o1.CreatedAt).unix() || 0) - (moment(o2.CreatedAt).unix() || 0))
          } else {
            return -(o1.ID - o2.ID)
          }
        })

        console.log(`this.sorting =`, this.sorting)
        this.tableData = this.searchedObjs.slice(0, 20)
      } catch (e) {
        console.error(e)
        alert(e)
      }
      return null
    },
    onExportExcel () {
      const exportExcel = () => {
        try {
          let datas = this.searchedObjs
          let result = ExcelGenerator.generate(this, datas, this.$store.state.coupon.list.list)

          var fileName = window.prompt(
            '請輸入匯出Excel檔之名稱',
            '旬果屋購物官網-商品月銷售報表匯出'
          )
          if (fileName === null) return // 取消
          if (!fileName) return window.alert('請輸入檔案名稱')
          XLSXSaver.saveAs(result, fileName)
        } catch (e) {
          alert('發生錯誤:' + e)
          window.console.error(`匯出異常`, e)
        }
      }

      // 1. load with details
      var ids = this.searchedObjs.map(o => o.ID)

      this.$services.order.getOrderListWithDetail(this, ids).then(res => {
        var orders = res.data.result
        for (let order of orders) {
          // let idx = this.$store.state.order.list.findIndex(o => o.ID === order.ID)
          // if (idx >= 0) this.$set(this.$store.state.order.list, idx, order)
          // this.filterObjs()
          let idx = this.searchedObjs.findIndex(o => o.ID === order.ID)
          if (idx >= 0) Object.assign(this.searchedObjs[idx], order)
        }
        // 2. export
        exportExcel()
      }).catch(this.$handleServiceError)
    },
    onCreate () {
      this.editingObj = null
      this.isShowAddeditModal = true
    },
    onUpdate (obj) {
      this.editingObj = obj
      this.isShowAddeditModal = true
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    onDateRangeChanged () {
      // this.filterObjs()
      // this.tableData = this.searchedObjs.slice(0, 20)
      this.search()
    },
    filterObjs () {
      if (!this.filteringProductID) {
        this.searchedObjs = []
        return
      }
      // if (!this.keyword && !this.filteringDateRange) {
      //   this.searchedObjs = this.$store.state.order.list
      //   return
      // }

      // const isObjFitKeyword = o => {
      //   if (!this.keyword) return true
      //   if (o.User && o.User.Username && o.User.Username.includes(this.keyword)) return true
      //   if (o.User && o.User.Profile && o.User.Profile.Name && o.User.Profile.Name.includes(this.keyword)) return true
      //   if (o.User && o.User.Profile && o.User.Profile.Email && o.User.Profile.Email.includes(this.keyword)) return true
      //   if (getOrderID(o).includes(this.keyword)) return true
      //   return false
      // }

      let startDate = this.filteringDateRange && moment(this.filteringDateRange[0])
      let endDate = this.filteringDateRange && moment(this.filteringDateRange[1])
      const isObjFitDateRange = o => {
        if (!this.filteringDateRange) return true
        let date = moment(o.CreatedAt)
        return (date.isBefore(endDate) && date.isAfter(startDate)) || date.isSame(startDate, 'date') || date.isSame(endDate, 'date')
      }

      const isFitProducID = o => {
        return o.OrderProducts.findIndex(p => p.ProductID == this.filteringProductID) >= 0
      }

      let yearMonthString = null
      if (this.filteringMonth) yearMonthString = moment(this.filteringMonth).format('yyyy-MM')
      const isFitMonth = o => {
        if (!yearMonthString) return true
        return moment(o.CreatedAt).format('yyyy-MM') == yearMonthString
      }

      let filteredOrders = this.$store.state.order.list.filter(u => {
        // return isObjFitKeyword(u) && isObjFitDateRange(u)
        return (u.PaymentStatus == '已付款') && isFitProducID(u) && isObjFitDateRange(u)// && isFitMonth(u)
      })
      filteredOrders.forEach(obj => {
        let orderProduct = obj.OrderProducts.find(o => o.ProductID == this.filteringProductID)
        obj.amountOfTheProduct = orderProduct.Amount * orderProduct.Price
      })
      this.searchedObjs = filteredOrders
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.TitleTw}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.order.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.order.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$store.state.order.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    this.currentPage = parseInt(this.$route.query.page) || 1
    if (this.$route.query.filteringDateRange) this.filteringDateRange = JSON.parse(this.$route.query.filteringDateRange)
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword

    const initTableData = () => {
      this.filterObjs()
      this.onChangePage(this.currentPage)
    }
    // query...
    this.$services.order.getAll(this).then(res => {
      this.$store.state.order.list = res.data.result
      initTableData()
    }).catch(this.$handleServiceError)

    this.$services.product.getAll(this).then(res => {
      this.$store.state.product.list = res.data.result
    }).catch(this.$handleServiceError)

    if (this.$store.state.coupon.list.list.length == 0) {
      this.$services.coupon.getAll(this).then(res => {
        this.$store.state.coupon.list.list = res.data.result
      })
    }
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
